export default "__VITE_ASSET__e271deea__"